import React from 'react';
import { TICKET_RES_MAP } from '../../config/ticket';
import styles from '../index.less';

const TicketResultPage = ({ scene, ID, title, subTitle, style, actions = [] }) => {
  // const status =
  //   scene === CREATE_SUCCESS_CODE ? 'success' : scene === EMPTY_ERROR_CODE ? 'empty' : 'error';
  const createResInfo = TICKET_RES_MAP[scene] || { title, subTitle };

  return (
    <div className={`${styles.resultPage} ${styles[`status${scene}`]}`} style={style}>
      <div className={styles.resInfo}>
        {title && <p className={styles.title}>{createResInfo.title}</p>}
        <p className={styles.subTitle}>{createResInfo.subTitle}</p>
      </div>
      {actions?.length > 0 && <div className={styles.actions}>{actions.map(el => el)}</div>}
    </div>
  );
};
export default TicketResultPage;
